import React from "react";
import { Helmet } from "react-helmet-async";
import "./About.css";
import AboutMission from "./AboutMission/AboutMission";

import img from "../../assets/about/sktt2.jpg";
import AboutJourney from "./AboutJourney/AboutJourney";

const AboutSkCollege = () => {
  return (
    <>
      <Helmet>
        <title>
          About Sucheta Kriplani Teacher Training College (SKTTC), Jodhpur |
          History & Affiliation
        </title>

        <meta
          name="description"
          content="Established in 2008, Sucheta Kriplani Teacher Training College (SKTTC), Manaklao, Jodhpur is a private self-financing B.Ed college affiliated with Jai Narain Vyas University (JNVU) and approved by NCTE. Dedicated to academic excellence and rural upliftment."
        />

        <meta
          name="keywords"
          content="Sucheta Kriplani Teacher Training College, SKTTC Jodhpur, B.Ed College Manaklao, JNVU Affiliated College, NCTE Approved B.Ed College Rajasthan, Teacher Training College Jodhpur"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="About SKTTC | Sucheta Kriplani Teacher Training College, Jodhpur"
        />

        <meta
          property="og:description"
          content="Learn about the history, mission, vision, affiliation, and academic excellence of SKTTC, established in 2008 in Manaklao, Jodhpur."
        />

        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://suchetabedcollege.org/about" />

        <meta
          property="og:image"
          content="https://suchetabedcollege.org/preview.jpg"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://suchetabedcollege.org/about" />
      </Helmet>

      <div className="about-page-about-sk-college-page">
        {/* ================= HERO SECTION ================= */}
        <section className="about-page-about-hero">
          <div className="about-page-hero-overlay"></div>
        </section>

        {/* ================= CONTENT WRAPPER ================= */}
        <div className="about-page-main-content-container">
          {/* ================= SPLIT SECTION ================= */}
          <section className="about-page-about-split-section">
            <div className="about-page-about-split-row">
              <div className="about-page-about-image-column">
                <img src={img} alt="SKTTC Campus" />
                <div className="image-accent-border"></div>
              </div>

              <div className="about-page-about-text-column">
                <h2 className="about-page-section-title-right">About SKTTC</h2>
                <h4 className="about-subtitle">
                  Sucheta Kriplani Teacher Training College
                </h4>

                <p>
                  Established in{" "}
                  <span className="about-page-gold-highlight">2008</span>,
                  Sucheta Kriplani Teacher Training College (SKTTC) stands as a
                  beacon of education in the rural heartland of{" "}
                  <span className="about-page-gold-highlight">
                    Manaklao, Jodhpur
                  </span>
                  . As a premier private co-educational institution, we are
                  dedicated to shaping the future of education.
                </p>
                <p>
                  We are proud to be affiliated with{" "}
                  <span className="about-page-gold-highlight">
                    Jai Narain Vyas University (JNVU)
                  </span>{" "}
                  and approved by the{" "}
                  <span className="about-page-gold-highlight">
                    National Council for Teacher Education (NCTE)
                  </span>
                  . Our core mission focuses on the professional development of
                  future educators through our comprehensive two-year{" "}
                  <span className="about-page-gold-highlight">
                    Bachelor of Education (B.Ed.)
                  </span>{" "}
                  program.
                </p>
              </div>
            </div>
          </section>

          {/* ================= INFRASTRUCTURE & INCLUSIVITY SECTION ================= */}
          <section className="about-page-teaching-paragraph-section">
            <div className="content-box">
              <h3 className="content-box-title">Campus & Inclusivity</h3>
              <p>
                Spanning a sprawling campus of approximately{" "}
                <span className="about-page-gold-highlight">6 acres</span>,
                SKTTC provides a serene learning environment equipped with
                specialized laboratories, a well-stocked library, and separate
                hostels to support our students' holistic growth.
              </p>
              <p>
                Beyond academics, the institution is notably recognized for its
                unwavering commitment to inclusivity. We operate a dedicated
                institute for{" "}
                <span className="about-page-gold-highlight">
                  physically challenged children
                </span>{" "}
                and provide specialized admission facilities and support for
                B.Ed. students with disabilities, ensuring that education
                remains accessible to all.
              </p>
            </div>
          </section>
        </div>

        <AboutMission />

        {/* ================= EXPERT FACULTY SECTION (Layout Preserved) ================= */}
        <section className="about-page-faculty-section-modern">
          <div className="about-page-story-container">
            <h2 className="about-page-faculty-title">Our Expert Faculty</h2>

            <div className="about-page-faculty-grid-modern">
              {/* Faculty Card 1 */}
              <div className="about-page-faculty-card-modern">
                <div className="about-page-faculty-card-bg-shape"></div>
                <div className="about-page-faculty-details">
                  <h3 className="about-page-faculty-name">Laxman singh</h3>
                  <div className="about-page-faculty-divider"></div>
                  <div className="about-page-faculty-designation-info">
                    <h4>Manager</h4>
                    <p className="about-page-faculty-experience">
                      15+ Years Experience
                    </p>
                  </div>
                </div>
              </div>

              {/* Faculty Card 2 */}
              <div className="about-page-faculty-card-modern">
                <div className="about-page-faculty-card-bg-shape"></div>
                <div className="about-page-faculty-details">
                  <h3 className="about-page-faculty-name">Sneh Gupta</h3>
                  <div className="about-page-faculty-divider"></div>
                  <div className="about-page-faculty-designation-info">
                    <h4>Executive director</h4>
                    <p className="about-page-faculty-experience">
                      15+ Years Experience
                    </p>
                  </div>
                </div>
              </div>

              {/* Faculty Card 3 */}
              <div className="about-page-faculty-card-modern">
                <div className="about-page-faculty-card-bg-shape"></div>
                <div className="about-page-faculty-details">
                  <h3 className="about-page-faculty-name">Bhairoon Singh Bhati</h3>
                  <div className="about-page-faculty-divider"></div>
                  <div className="about-page-faculty-designation-info">
                    <h4>Secretary</h4>
                    <p className="about-page-faculty-experience">
                      15+ Years Experience
                    </p>
                  </div>
                </div>
              </div>

              {/* Faculty Card 4 */}
              <div className="about-page-faculty-card-modern">
                <div className="about-page-faculty-card-bg-shape"></div>
                <div className="about-page-faculty-details">
                  <h3 className="about-page-faculty-name">Laxman Singh Ji</h3>
                  <div className="about-page-faculty-divider"></div>
                  <div className="about-page-faculty-designation-info">
                    <h4>Physical Instructor</h4>
                    <p className="about-page-faculty-experience">
                      15+ Years Experience
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <AboutJourney />
      </div>
    </>
  );
};

export default AboutSkCollege;
